import styled from "styled-components";

import { getWindowHeight } from "../../utils";

export const Header = styled.h1`
  /* Tablet/H1 */
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 120%;

  /* or 36px */
  display: flex;
  align-items: center;

  /* Donkergrijs */
  color: #212529;
`;

export const Container = styled.div`
  display: flex;
`;

export const ColumnsContainer = styled.div`
  display: flex;
  flex-grow: 1;
  height: ${getWindowHeight()};
  overflow: auto;
  flex-direction: row;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ColumnLeft = styled.div`
  padding: 10px;
  flex: 2;
  @media only screen and (max-width: 768px) {
    flex: unset;
    height: unset;
  }
`;

export const ColumnRight = styled.div`
  flex: 1;
  display: flex;
  float: right;
  flex-direction: column;
  background-color: white;
  @media only screen and (max-width: 768px) {
    flex: unset;
    height: unset;
  }
`;

export const ColumnHeader = styled.div`
  align-items: center;
  padding: 15px;
  padding-left: 28px;
  /* Mediumgrijs */
  border-bottom: 1px solid #e5e5e5;
`;

export const DetailColumn = styled.div`
  background-color: white;
  h3 {
    /* Tablet/H3 */
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 120%;

    /* identical to box height, or 22px */

    /* Donkergrijs */
    color: #212529;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  padding-top: 13px;
  padding-left: 28px;
  padding-right: 20px;
  padding-bottom: 13px;
`;

export const InspectionFieldTable = styled.table`
  font-size: 13px;
  font-style: normal;
  font-family: "Roboto";
  /* Donkergrijs */
  color: #212529;
  font-size: 13px;
  line-height: 120%;
  th {
    text-align: left;
    /* Tablet/Label bold */
    font-weight: 700;
    min-width: 50%;
    padding-top: 6px;
    padding-bottom: 6px;
    padding-right: 6px;
  }
  td {
    padding-top: 6px;
    padding-bottom: 6px;
    font-weight: 400;
  }
`;

export const Spacer = styled.span`
  margin-left: 14px;
`;
